import { Button, Form, List, Space, message } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import { useEffect, useState } from "react";
import { ApiService, RequestComment } from "../api";

type Props = {
  schema: any;
  formProps: any;
  formId?: number;
  requestId?: number;
  readonly?: boolean;
  values?: any;
  onSuccess: (result: any) => void;
  duplicateRequestId?: number | undefined;
  setDuplicateRequestId?: (duplicateRequestId: number | undefined) => void;
  showPrev?: boolean;
  onPrev?: () => void;
};

const CommentComponent = ({
  schema,
  formProps,
  formId,
  requestId,
  readonly,
  values,
  onSuccess,
  duplicateRequestId,
  setDuplicateRequestId,
  showPrev,
  onPrev,
}: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [comments, setComments] = useState<any[]>([]);
  const [fetch, setFetch] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const handleFinish = async (values: any) => {
    try {
      setLoading(true);
      const result = await ApiService.apiMainRequestFormCreate({
        form_id: formId ?? 0,
        request_id: requestId ?? null,
        data: values,
      });
      message.success(t("Comment has been added successfully"));
      setFetch(fetch + 1);
      setLoading(false);
      getFormValues(requestId, formId);
    } catch (e) {
      message.error(t("Something went wrong"));
    }
    form.resetFields();
  };

  useEffect(() => {
    getFormValues(requestId, formId);
  }, [fetch]);

  const getFormValues = async (requestId?: number, form_id?: number) => {
    if (!requestId) return undefined;
    const result = await ApiService.apiMainRequestFormRetrieve(
      form_id!,
      requestId!
    );

    setComments(result);
  };

  return (
    <>
      <Form form={form} onFinish={handleFinish}>
        <Form.Item labelCol={{ span: 8 }} wrapperCol={{ span: 8, offset: 8 }}>
          <div
            id="scrollableDiv"
            style={{
              maxHeight: 600,
              overflow: "auto",
            }}
          >
            <List
              loading={loading}
              dataSource={comments}
              renderItem={(item) => (
                <List.Item key={item.id}>
                  <List.Item.Meta
                    title={
                      <a>
                        {item.created_by} |{" "}
                        {moment(item.created_at).format("DD/MM/yyyy hh:mm")}
                      </a>
                    }
                    description={item.text}
                  />
                </List.Item>
              )}
            />
          </div>
        </Form.Item>
        <Form.Item
          name="comment"
          label={t("New comment")}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 8 }}
        >
          <TextArea placeholder={t("Type comment")} />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 8 }} name="submitButton">
          <Space>
            {showPrev && (
              <Button style={{ width: "6em" }} onClick={onPrev}>
                {t("Previous")}
              </Button>
            )}
            <Button type="primary" htmlType="submit" style={{ width: "6em" }}>
              {t("Save")}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </>
  );
};

export default CommentComponent;
